import BackendConnector from './backendConnector';

export default class ComplianceHttpService {
    static checkIfPositionIsGdprCompliant({ locations }) {
        return BackendConnector.post('/compliance/position/gdpr', { locations });
    }

    static getPositionGdprLocations({ locations }) {
        return BackendConnector.post('/compliance/position/locations/gdpr', { locations });
    }
}
